import { get } from 'lodash';
import XLSX from 'xlsx';

function headerColumnsSize(headerLine) {
  return Object.keys(headerLine).map(key => {
    return {
      key: key,
      width: headerLine[key].toString().length + 10,
    };
  });
}

export function generateDataExcel(data, columns) {
  const result = data.map(line => {
    const newline = columns.map(c => c.key).reduce((a, c) => {
      a[c] = get(line, c);
      return a;
    }, {});
    return newline;
  });
  const addLabel = columns.reduce((a, c) => { return { ...a, [c.key]: c.label }; }, {});
  result.unshift(addLabel);
  return result;
}

export function generateSheetExcel(sheet) {
  const dataSheet = generateDataExcel(sheet.data, sheet.columns);
  const mappedSheet = XLSX.utils.json_to_sheet(dataSheet, { skipHeader: sheet.skipHeader });
  mappedSheet['!cols'] = headerColumnsSize(dataSheet[0]);
  return mappedSheet;
}

export function ExportToExcel(data) {
  const file = XLSX.utils.book_new();

  data.sheets.forEach(sheet => {
    const sheetgenerated = generateSheetExcel(sheet);
    XLSX.utils.book_append_sheet(file, sheetgenerated, sheet.name);
  });
  XLSX.writeFile(file, data.name);
}
